import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';

/**
 * Modal genérico para mostrar mensajes y ejecutar funciones
 * @param {String} texto1 Texto a mostrar en el modal al abrirlo (obligatorio)
 * @param {String} texto2 Texto a mostrar en el cuerpo del modal si todo ha ido bien (obligatorio)
 * @param {String} texto3 Texto a mostrar en el título del modal (obligatorio)
 * @param {String} texto4 Texto a mostrar en el cuerpo del modal si ha habido un error
 * @param {Function} navegar Función para navegar a otra página (obligatorio)
 * @param {Function} navegarError Función para navegar a otra página si ha habido un error (obligatorio)
 * @param {Boolean} show Mostrar el modal (obligatorio)
 * @param {Function} onHide Función para cerrar el modal (obligatorio)
 * @param {Function} func Función a ejecutar al pulsar el botón de aplicar (obligatorio)
 * @param {Function} setMensaje Funcion para cambiar el mensaje de error o informacion si lo hubiera (obligatorio)
 * @returns 
 */
const ModalGenerico = ({texto1, texto2, texto3, texto4, navegar, navegarError, show, onHide, func, setMensaje}) => {

	const [error, setError] = useState(''); //mostrar mensajes
	const [cambioOk, setCambioOk] = useState(1); //cambiar el modal y mostrar que ha cambiado la contraseña. 0: ok, 1: no ha cambiado, 2: error

	/**
	 * Comprueba que las contraseñas sean correctas y las cambia
	 */
	const ejecutar = async () => {
		const res = await func()
		if (res===0) 
			setCambioOk(0)
		else
			setCambioOk(2)
	}

	//cada vez que se abre o cierra el modal, se resetean los campos
	useEffect(() => {
		setError('')
		setCambioOk(1)
	}, [show])

	if (!show || !texto1 || !texto2 || !texto3 || !func || !navegar || !setMensaje)
		return ("")
	else
		return (
			<Modal
				className="modal_campos"
				show={show}
				onHide={onHide}
				animation={false}
				centered
				size="lg"
			>
				<div id="modalcambiopass">
					<Modal.Body>
						<h2>{texto3}</h2>
						{cambioOk===1 ?
							<div>
								<p>{texto1}</p>
							</div>
						:cambioOk===0 ?
							<div>
								<p>{texto2}</p>
							</div>
						:cambioOk===2 &&
							<div>
								<p>{texto4??'Ha habido un error'}</p>
							</div>
						}

					</Modal.Body>
				</div>

				<Modal.Footer>
					<p>{error}</p>
					<div className='button-container'>
						{cambioOk===1 ?
							<>
								<button className='cta'
									onClick={() => { ejecutar() }}
								>
									Aplicar
								</button>
								<button
									onClick={() => {
										onHide();
									}}
								>
									Cancelar
								</button>
							</>
							:cambioOk===0 ?
							<button
								onClick={() => {
									onHide();
									navegar();
								}}
							>
								Cerrar
							</button>
							: cambioOk===2 &&
							<button
								onClick={() => {
									setMensaje(''); //elimina el mensaje para volver a ver los datos
									onHide();
								}}
							>
								Cerrar
							</button>
						}
					</div>
				</Modal.Footer>
			</Modal>
		)
}

export default ModalGenerico